var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelTumblr = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.586 4.05 12.455 4l-.101 3.826H17v3.031l-4.646-.05.05 4.522c.531 2.984 3.492 1.95 4.596.895v2.534c-.858.67-2.554 1.174-3.94 1.242-2.382-.252-4.425-1.014-4.545-4.67v-4.473H7V7.876c1.951-.126 3.714-.563 3.586-3.826"
})));
export default SvgGemChannelTumblr;